(function () {
  /**
   * @ngdoc directive
   * @name kareo.ui.shared.assets:kStepNav
   * @restrict E
   * @scope
   * @description
   * Step Navigation / Wizard
   *
   * @param {Number | function} currentStep Source of current step to data-bind to.
   * @param {Array} steps Array of steps to generate nav from
   * @example
   <example module="kareo.ui.shared.directives.k-step-nav">
   <file name="index.html">
   <div ng-controller="KStepsNavDemoCtrl" class="kareo" >
   <k-step-nav current-step="currentStep" steps="steps"></k-step-nav>
   <p>
   <a href="#" ng-click="nextStep()">
   Next
   </a>
   |
   <a href="#" ng-click="prevStep()">
   Previous
   </a>
   </p>
   </div>
   </file>
   <file name="demo.js">
   var app = angular.module('kareo.ui.shared.directives.k-step-nav');

   app.controller('KStepsNavDemoCtrl', ['$scope', function($scope){

       $scope.currentStep = 1;
       $scope.steps = [
         {title: 'Step 1'},
         {title: 'Step 2'},
         {title: 'Step 3'},
         {title: 'Step 4'}
       ];

       $scope.nextStep = function(){
         if($scope.currentStep < 4)
           $scope.currentStep++;
       };

       $scope.prevStep = function(){
         if($scope.currentStep > 1)
           $scope.currentStep--;
       };
     }]);
   </file>
   </example>
   */

  angular
    .module('kareo.ui.shared.directives.k-step-nav', [])
    .directive('kStepNav', kStepNav);
  function kStepNav() {
    var directive = {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      restrict: 'E',
      template: require('./k-step-nav.pug')(),
      scope: {
        currentStep: '=', steps: '='
      }
    };
    return directive;
  }

// /////////////////////////////////////////////////////////////////////////////
  function controller() {
    var vm = this;
    vm.getClass = getClass;
    // ///////////////////////////////////////////////////////////////////////////
    function getClass(stepIndex) {
      var currentStep = getCurrentStep(), stepNum = stepIndex + 1;
      if (currentStep === stepNum) {
        return 'active';
      } else if (currentStep > stepNum) {
        return 'complete';
      }
        return 'inactive';
    }

    function getCurrentStep() {
      var currentStep;
      if (angular.isFunction(vm.currentStep)) {
        currentStep = vm.currentStep();
      } else {
        currentStep = vm.currentStep;
      }
      return Number(currentStep);
    }
  }
})();
